import { render } from "./ColorModal.vue?vue&type=template&id=9e142f34&scoped=true"
import script from "./ColorModal.vue?vue&type=script&lang=js"
export * from "./ColorModal.vue?vue&type=script&lang=js"

import "./ColorModal.vue?vue&type=style&index=0&id=9e142f34&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e142f34"]])

export default __exports__